import { ReponseMotifs } from '../../models/reponses/reponse-motifs';
import { ReponseEnveloppe } from '../../models/reponses/reponse-enveloppe';

export const reponseMotifs: ReponseEnveloppe<ReponseMotifs> = {
    "reponse": {
        "motifs": [
            {
                "idMotif": 1,
                "libelleMotif": "Offre",
                "sousMotifs": [
                    {
                        "idSousMotif": 1,
                        "libelleSousMotif": "Insatisfaction tarif abonnement",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 2,
                        "libelleSousMotif": "Concurrence",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 3,
                        "libelleSousMotif": "Fin de promotion",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 4,
                        "libelleSousMotif": "Ligne non utilisée",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 5,
                        "libelleSousMotif": "Services insuffisants/inadaptés",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 6,
                        "libelleSousMotif": "Inéligibilité à la fibre",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    }
                ]
            },
            {
                "idMotif": 2,
                "libelleMotif": "Problème technique récurrent",
                "sousMotifs": [
                    {
                        "idSousMotif": 7,
                        "libelleSousMotif": "Absence totale de service",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 8,
                        "libelleSousMotif": "Problème technique Internet et téléphone",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 9,
                        "libelleSousMotif": "Problème technique qualité TV",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 10,
                        "libelleSousMotif": "Problème d'activation",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    }
                ]
            },
            {
                "idMotif": 3,
                "libelleMotif": "Déménagement",
                "sousMotifs": [
                    {
                        "idSousMotif": 11,
                        "libelleSousMotif": "Déménagement chez tiers déjà équipé",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 12,
                        "libelleSousMotif": "Nouveau logement déjà équipé",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 13,
                        "libelleSousMotif": "Déménagement à l'étranger et DOM d'une durée de plus de 6 mois",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants (Français, Anglais, Espagnol) :<br>\ncontrat de travail à l'étranger d'une durée supérieure à 6 mois<br><strong>ou</strong> avis de mutation professionnelle d'une durée supérieure à 6 mois<br><strong>ou</strong> convention de stage à l'étranger d'une durée supérieure à 6 mois (ou si le document stipule Année scolaire 20XX/20XX)<br>\n<strong>ou</strong> document attestant d'une année d'études à l'étranger, avec tampon de l'école / université (ou si le document stipule Année scolaire 20XX/20XX)<br><strong>ou</strong> avis d'imposition à l'étranger<br><strong>ou</strong> bail ou contrat de location à l'étranger d'une durée supérieure à 6 mois<br>\n<strong>ou</strong> facture de déménagement pour l'étranger -si militaire en mission à l'étranger : document du supérieur hiérarchique avec tampon, d'une durée supérieure à 6 mois<br><strong>ou</strong> injonction administrative de quitter le territoire - si cette injonction date de plus de 3 mois, fournir en plus le rejet de recours par le Tribunal ou par le Préfet.",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 14,
                        "libelleSousMotif": "Déménagement France métropolitaine vers zone non couverte",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>copie de l'acte d'achat du nouveau logement datant de moins de 3 mois<br><strong>ou</strong> copie du bail ou contrat de location du nouveau logement datant de moins de 3 mois<br><strong>ou</strong> copie de l'acte de fin de chantier datant de moins de 3 mois<br><strong>ou</strong> contrat de travail ou avis de mutation professionnelle datant de moins de 3 mois<br><strong>ou</strong> ordre de mission d'une durée supérieure à 1 an et datant de moins de 3 mois (à condition que l'adresse du lieu de travail y figure)",
                        "profil": "ALL"
                    }
                ]
            },
            {
                "idMotif": 4,
                "libelleMotif": "Relation avec SFR",
                "sousMotifs": [
                    {
                        "idSousMotif": 15,
                        "libelleSousMotif": "Insatisfaction relation client",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 16,
                        "libelleSousMotif": "Contestation facturation",
                        "legitime": false,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    }
                ]
            },
            {
                "idMotif": 5,
                "libelleMotif": "Motifs légitimes / L224-33 c.consommation",
                "sousMotifs": [
                    {
                        "idSousMotif": 22,
                        "libelleSousMotif": "Décès",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 2,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre les justificatifs suivants :<br>copie de l'acte de décès du client ou Procès-verbal de constatation de décès<br><strong>et</strong> copie de la pièce d'identité du demandeur",
                        "profil": "ALL,DISTRIB"
                    },
                    {
                        "idSousMotif": 17,
                        "libelleSousMotif": "Rupture d'un CDI",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>attestation destinée au Pôle Emploi remise par l'employeur mentionnant la rupture d'un Contrat à Durée Indéterminée (CDI) datant de moins de 3 mois<br><strong>ou</strong> avis de situation fourni par le Pôle Emploi datant de moins de 3 mois.",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 18,
                        "libelleSousMotif": "Faillite personnelle / Redressement judiciaire / Liquidation judiciaire",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>copie du jugement datant de moins de 6 mois<br><strong>ou</strong> copie de la réponse du Tribunal ou de la Banque de France confirmant la faillite personnelle",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 19,
                        "libelleSousMotif": "Dissolution, fermeture de société",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 2,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre les justificatifs suivants :<br>l'extrait Kbisl<br><strong>et</strong> procès-verbal de l'Assemblée Générale Ordinaire (AGO) ayant prononcé la clôture des opérations de liquidation",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 20,
                        "libelleSousMotif": "Auto-entrepreneur : fin d'activité",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre le justificatif suivant :<br>certification de radiation URSSAF / CFE.",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 28,
                        "libelleSousMotif": "Modification du contrat non souhaitée",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": true,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": null,
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 21,
                        "libelleSousMotif": "Surendettement",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre le justificatif suivant :<br>avis de notification de recevabilité en Commission de Surendettement daté de moins de 6 mois.",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 23,
                        "libelleSousMotif": "Hospitalisation / Arrêt maladie / Invalidité",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>certificat d'hospitalisation datant de moins de 4 mois et annoncer une durée d'hospitalisation / d'arrêt / d'invalidité cumulée de plus de 3 mois<br><strong>ou</strong> certificat médical (CERFA) dater de moins de 4 mois et annoncer une durée d'hospitalisation / d'arrêt / d'invalidité cumulée de plus de 3 mois",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 25,
                        "libelleSousMotif": "Placement en maison de retraite / Placement structure médicale spécialisée",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre le justificatif suivant :<br>attestation d'hébergement en Maison de retraite ou structure spécialisée (EHPAD, MAPA, MAPAD, MARPA) datant de moins de 4 mois",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 24,
                        "libelleSousMotif": "Incarcération",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>jugement daté de moins de 3 mois<br><strong>ou</strong> avis d'incarcération daté de moins de 3 mois<br><strong>ou</strong> certificat de la maison d'arrêt daté de moins de 3 mois<br><strong>ou</strong> mandat de dépôt daté de moins de 3 mois<br><strong>ou</strong> bulletin de situation du greffe de prison daté de moins de 3 mois",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 26,
                        "libelleSousMotif": "Cas de force majeure",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>attestation de l'Assurance reconnaissant le cas de force majeure<br><strong>ou</strong> dans le cas d'une catastrophe naturelle, envoyer la déclaration de sinistre",
                        "profil": "ALL"
                    },
                    {
                        "idSousMotif": 27,
                        "libelleSousMotif": "Sans domicile fixe",
                        "legitime": true,
                        "commentaireClient": true,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": true,
                        "nbrePiecesJointesMin": 1,
                        "libellePiecesJointes": "Pour finaliser votre demande, joindre l'un des justificatifs suivants :<br>attestation produite par le Samu Social (115)<br><strong>ou</strong> attestation d'élection de domicile",
                        "profil": "ALL"
                    }
                ]
            },
            {
                "idMotif": 6,
                "libelleMotif": "Ne souhaite pas répondre",
                "sousMotifs": [
                    {
                        "idSousMotif": 29,
                        "libelleSousMotif": "Ne souhaite pas répondre",
                        "legitime": false,
                        "commentaireClient": false,
                        "commentaireClientMandatory": false,
                        "piecesJointesNeeded": false,
                        "nbrePiecesJointesMin": 0,
                        "libellePiecesJointes": "Vos éventuels frais de résiliation sont calculés selon le motif que vous avez sélectionné.<br>En choisissant « Ne souhaite pas répondre », ces frais de résiliation vous seront facturés au plein tarif par défaut.<br><br>Afin de déterminer si vous êtes dans une situation d'exonération de frais de résiliation, nous vous remercions de sélectionner le motif associé.<br>Vos frais seront alors calculés selon votre situation et vous bénéficierez de l'exonération de ces frais après validation de vos pièces justificatives.",
                        "profil": "ALL"
                    }
                ]
            }
        ]
    }
}
